import { logError } from '@log';
import { request } from './request';
// import { MOCK_SUBMIT_RESP } from './mock';

/**
 * 提交理赔申请
 * @param {*} body body
 */
export const submitClaim = async ({ path, headers, ...body }) => {
  // console.log('submit-claim-request', body);
  // const resp = MOCK_SUBMIT_RESP;
  try {
    const resp = await request('submit-claim', { body, path, headers });
    if (!resp) {
      logError(new Error('submit-claim no resp'));
      return null;
    }
    return resp;
  } catch (error) {
    logError(error);
    return null;
  }
};
